/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {prepareSparkWalletUpgrade} from '../api'

export const useMutationPrepareSparkWalletUpgrade = createReactQueryMutationHook('prepareSparkWalletUpgrade', prepareSparkWalletUpgrade)
